// Centralized Elk Creek Marina content & assets
// All photos now served from /public/photos (sourced from client's Drive folder).

export const SITE = {
  name: "Elk Creek Marina",
  tagline: "Lake Tenkiller, Oklahoma",
  phoneDisplay: "(918) 457-5142",
  phoneRaw: "+19184575142",
  email: "Elkcreekresortok@gmail.com",
  address: "22911 W 877 Rd, Park Hill, OK 74451",
  facebook: "https://www.facebook.com/ElkCreekResort",
  instagram: "https://www.instagram.com/elkcreekmarinaok/",
  directions:
    "https://www.google.com/maps/dir/?api=1&destination=22911%20W%20877%20Rd,%20Park%20Hill,%20OK,%20USA,%2074451",
  bookingUrl: "#book",
  siteUrl: "https://elkcreek-cabinrentals-marina.com",
  privacyPolicyApproved: true,
  logo: "/logo.png",
  hero: "/photos/hero-drone.jpg",
};

export const PHOTOS = {
  // Hero drone shot of the marina (also doubles as a marina aerial)
  heroDrone: "/photos/hero-drone.jpg",
  // Cabin exteriors only (no interiors anywhere on the site)
  cabinRow: "/photos/IMG_7927.jpg",
  cabinDeck: "/photos/IMG_7929.jpg",
  cabinDeckTables: "/photos/IMG_2551_2.jpg",
  cabinDeckTables2: "/photos/IMG_2552.jpg",
  cabinDeckLong: "/photos/IMG_2553.jpg",

  // Marina
  marinaSign: "/photos/IMG_2544.jpg",
  marinaStore: "/photos/IMG_7463.jpg",
  marinaBoatDeck: "/photos/IMG_2523.jpg",
  marinaBoatDeck2: "/photos/IMG_2525.jpg",
  marinaPontoonDocked: "/photos/IMG_6995.jpg",

  // Lake scenic
  lakeHills: "/photos/IMG_2540.jpg",
  lakeWake: "/photos/IMG_2542.jpg",
  lakeSunset: "/photos/IMG_6684.jpg",

  // Boating / water activities
  tubing: "/photos/IMG_1376.jpg",
  pontoonClassic: "/photos/IMG_2129.jpg",
  pontoonGroup: "/photos/IMG_2489.jpg",
  pontoonCruise: "/photos/IMG_5187.jpg",
  kayakPov: "/photos/IMG_2506.jpg",
  kayakYellow: "/photos/IMG_2551.jpg",
  funSelfie: "/photos/IMG_9364.jpg",
};

export const PAGE_META = {
  "/": {
    title: "Elk Creek Marina — Cabin Rentals & Marina on Lake Tenkiller, OK",
    description: "Pet-friendly lake cabins, boat slips, a gas dock and rentals on the north end of Lake Tenkiller in Park Hill, Oklahoma.",
  },
  "/cabins": {
    title: "Cabin Rentals | Elk Creek Marina, Lake Tenkiller",
    description: "Clean, well-stocked, pet-friendly cabins that sleep up to 8, steps from the dock. Rates, sleeping layout and stay policies.",
  },
  "/marina": {
    title: "Marina, Boat Slips & Gas Dock | Elk Creek Marina",
    description: "Day slips, yearly slip rentals, a gas dock and convenience store on Lake Tenkiller. Call to check slip availability.",
  },
  "/boating": {
    title: "Boating & Water Rentals | Elk Creek Marina",
    description: "Pontoon boats, kayaks, paddleboards and tubing on Lake Tenkiller from Elk Creek Marina.",
  },
  "/faq": {
    title: "FAQ & Directions | Elk Creek Marina",
    description: "Directions, what's included in the cabins, pet and cancellation policies, day slips and things to do at Lake Tenkiller.",
  },
  "/contact": {
    title: "Contact Us | Elk Creek Marina",
    description: "Call (918) 457-5142 or send a message to Elk Creek Marina, 22911 W 877 Rd, Park Hill, OK 74451.",
  },
  "/accessibility": {
    title: "Accessibility | Elk Creek Marina",
    description: "Our commitment to an accessible website and how to reach us if something doesn't work for you.",
  },
  "/admin": {
    title: "Messages | Elk Creek Marina",
    description: "Staff only.",
  },
  "/privacy": {
    title: "Privacy Policy | Elk Creek Marina",
    description: "How Elk Creek Marina handles information you share through this website.",
  },
};

export const CABIN_FEATURES = [
  "Clean & well-stocked",
  "Easy access",
  "Close to marina",
  "Close parking",
  "Entertainment deck",
  "Dishes, silverware, cookware",
  "Bedding included",
  "Outdoor grill",
];

export const CABIN_INFO = {
  rates: [
    { label: "Prime Season (May – Sept)", price: "$160 / night" },
    { label: "Off-Season", price: "$140 / night" },
  ],
  policies: [
    "Checkout time is 10:00 AM",
    "Credit card required at booking",
    "2-week cancellation policy",
    "Weekends: 2-day minimum",
    "Holiday weekends (4th of July, Memorial, Labor Day): 3-day minimum",
  ],
  sleeping: [
    "Most cabins have a king bedroom + queen bedroom",
    "Living area has a full-size futon",
    "Loft has a full-size futon mattress",
    "One cabin has two full-size bedrooms + futon in loft + futon in living area",
    "Sleeps an average of up to 8 people comfortably",
    "All cabins combined can host roughly 32 guests for group events",
  ],
};

export const MARINA_SERVICES = [
  {
    title: "Day Slips",
    body: "A limited number of day slips for visitors. Call ahead for details and current availability.",
  },
  {
    title: "Yearly Slip Rental",
    body: "Newly constructed dock spaces with limited availability. We are continually adding slips — call to check.",
  },
  {
    title: "Gas Dock",
    body: "Fuel up right on the water without leaving the lake.",
  },
  {
    title: "Convenience Store",
    body: "Basic boating needs, snacks, and Elk Creek Resort clothing on-site.",
  },
  {
    title: "Boat & Paddleboard Rentals",
    body: "Boats and paddleboards available so you can enjoy Tenkiller without bringing your own gear.",
  },
  {
    title: "Easy Lake Access",
    body: "We sit near the north end of Lake Tenkiller with quick access to 12,900 acres of water and 130 miles of shoreline.",
  },
];

export const ACTIVITIES = [
  "Boating",
  "Fishing",
  "Swimming in the Cove",
  "Wakeboarding",
  "Tubing",
  "Skiing",
  "Paddleboarding",
  "Kayaking",
  "Cliff Jumping",
  "Camping",
  "Scuba (see the original town of Cookson)",
  "Visiting floating restaurants on the lake",
];

export const THINGS_TO_BRING = [
  "Water Shoes",
  "Charcoal",
  "Beach Towels",
  "Sunscreen",
  "Bug Spray",
  "Children's Safety Vests",
  "Fun Float Devices",
];

export const FAQ_ITEMS = [
  {
    q: "What's the best way to get to Elk Creek Marina?",
    a: "From Highway 82, turn West off of 560 Rd — on the south side of Flintridge Grocery and Gas, and across from Princess Restaurant. You'll also see a sign that says Whitetail Run. Follow the road west for about a half mile and it will open into the resort. We are on the EAST side of the lake, just south of the major bridge that crosses the north end of Tenkiller.",
  },
  {
    q: "What's included in the cabins?",
    a: "Blankets, towels (for cabin use only), dishes, silverware, cookware, bedding, serving utensils, and an outdoor grill. Most cabins sleep up to 8 comfortably with a king bedroom, queen bedroom, plus futons in the living area and loft.",
  },
  {
    q: "Are pets allowed?",
    a: "Yes — all of our cabins are pet-friendly. Please let us know in advance if you're bringing a pet so we can get you set up.",
  },
  {
    q: "What's the cancellation policy?",
    a: "We have a 2-week cancellation policy. A credit card is required at booking, and checkout is at 10:00 AM.",
  },
  {
    q: "Do you have slips for the day?",
    a: "Yes — we have a limited number of day slips. Please call ahead at (918) 457-5142 so we can confirm availability and walk you through the options.",
  },
  {
    q: "What do people do at Elk Creek?",
    a: "Boating, fishing, swimming in the cove, wakeboarding, tubing, skiing, paddleboarding, kayaking, cliff jumping, camping, scuba diving (you can see the original town of Cookson), or just relaxing on the deck.",
  },
];

export const BOATING_OFFERINGS = [
  {
    title: "Boat Rentals",
    body: "Pontoon boats ready to roll for a day on Tenkiller. Great for families, groups, and lazy lake afternoons.",
  },
  {
    title: "Kayak Rentals",
    body: "Single and tandem kayaks to explore the coves at your own pace.",
  },
  {
    title: "Tubing & Towables",
    body: "Tubes, ropes and pulls for a classic Tenkiller summer day behind the boat.",
  },
  {
    title: "Paddleboards",
    body: "Stand-up paddleboards for calm-water cruising and sunset paddles.",
  },
  {
    title: "Other Water Activities",
    body: "Wakeboarding, skiing, swimming in the cove and more — ask us what's available.",
  },
];
